import React from 'react'

const Spinner = () => (
    <div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '8%'}}>
       <img src="/images/spinner.gif" alt="loading..."/>
    </div>
)

export default Spinner
